import { PlanningData } from 'appTypes';

import assign from 'lodash/assign';
import fromPairs from 'lodash/fromPairs';

import { DayTypes } from 'appConstants';
import {
  bin_size_to_minutes,
  MINUTES_PER_DAY,
  volume_data_map,
} from '../chart/PlanningChartDataExpander';

export type VolumeTableData = {
  Time: string;
  [DayTypes.Friday]?: string;
  [DayTypes.Saturday]: string;
  [DayTypes.Sunday]?: string;
  [DayTypes.Weekday]?: string;
  [DayTypes.MeWeekday]?: string;
};

const zeroPad = (num, places) => String(num).padStart(places, '0');
const displayMinutes = (minutes) =>
  `${String(Math.floor(minutes / 60))}:${zeroPad(minutes % 60, 2)}`;

// const debabelize = (babylonian: number) =>
//   Math.floor(babylonian / 100) * 60 + (babylonian % 100);

export class PlanningTableDataExpander {
  binSize: number;
  firstBin: number;
  lastBin: number;
  numBins: number;

  constructor(binSize: string) {
    this.binSize = bin_size_to_minutes(binSize);
    this.numBins = MINUTES_PER_DAY / this.binSize;
    this.firstBin = 0;
    this.lastBin = this.firstBin + this.numBins;
    // console.log(`numBins ${this.numBins} firstBin ${this.firstBin} lastBin ${this.lastBin}`);
  }

  toIndex(bin) {
    const minutes = Math.floor(bin / 100) * 60 + (bin % 100);
    const index = minutes / this.binSize;
    return index;
  }

  displayBin(bin) {
    return `${displayMinutes(bin)} - ${displayMinutes(bin + this.binSize)}`;
  }

  expandData(rawData: PlanningData): Array<VolumeTableData> {
    // extract and backfill sparse SpeedData array with null datapoints for all time bins
    const data = Array(this.numBins);
    for (let idx = 0; idx < this.numBins; idx += 1) {
      const b = this.firstBin + idx * this.binSize;
      data[idx] = { Time: this.displayBin(b) };
    }

    if (!rawData) {
      return data;
    }

    // Initialize sums dynamically based on the day types in the data
    const sums: { [key: string]: number } = {};
    if (rawData.data.length > 0) {
      // Get unique day types from the data
      const dayTypes = [
        ...new Set(
          rawData.data.map(
            (d) => d[0], // day
          ),
        ),
      ];
      dayTypes.forEach((dayType) => {
        sums[dayType] = 0;
      });
    }

    const sparseData = rawData.data.map(volume_data_map);
    for (let idx = 0; idx < sparseData.length; idx += 1) {
      const { day, bin, y } = sparseData[idx];
      const index = this.toIndex(bin);
      console.assert(index % 1 === 0, day, bin, y);
      const roundedY = Math.round(y);
      assign(data[index], fromPairs([[day, roundedY]]));

      // Add to daily sum
      sums[day] += roundedY;
    }

    // Create summary row and add it to the beginning of the array
    // @ts-ignore
    const summaryRow: VolumeTableData = {
      Time: 'All Day Total',

      ...Object.fromEntries(
        Object.entries(sums).map(([day, sum]) => [day, sum]),
      ),
    };

    return [summaryRow, ...data];
  }
}
